import Select from "../../js/select";
import LazyLoad from "vanilla-lazyload";
import ReadMore from '../../js/readmore';

const container = document.querySelector(`#products-container`);

const opacityPromise = 0.6;
const promiseHandlers = [
    'onFilter',
    'onPaginate',
];

addEventListener('ajax:promise', (e) => {
    const { context } = e.detail;

    productsPromise( context.handler );
});

container.addEventListener('ajax:update', () => {
    productsSuccess();
});  

const productsPromise = (handler) => {
    if( promiseHandlers.includes(handler) ) {
        container.style.opacity = opacityPromise;
    } 
}

const productsSuccess = () => {
    // add listeners to inputs
    container.style.opacity = 1.0;
    Select.init();
    ReadMore.init();
    new LazyLoad();
}